(function ($, nette) {

  var loadInProgress = false;

  $.fn.scrollPagination = function (options) {
    var opts = $.extend($.fn.scrollPagination.defaults, options);
    var target = opts.scrollTarget;
    if (target == null) {
      target = obj;
    }
    opts.scrollTarget = target;
    
    $.nette.ext('scrollPagination', {
      'start': function(jqXHR, settings) {
        console.log("scroll load start");
        loadInProgress = true;
      },
      'complete': function(jqXHR, settings) {
        console.log("scroll load stop");
        loadInProgress = false;
      }
    });

    return this.each(function () {
      $.fn.scrollPagination.init($(this), opts);
    });
  };

  $.fn.stopScrollPagination = function () {
    return this.each(function () {
      $(this).attr('scrollPagination', 'disabled');
    });
  };

  $.fn.scrollPagination.loadContent = function (obj, opts) {
    var target = opts.scrollTarget;
    var mayLoadContent = $(target).scrollTop() + opts.heightOffset >= $(document).height() - $(target).height();
    console.log("scroll load check");
    if (mayLoadContent && !loadInProgress) {
      console.log("scroll load loading");
      if (opts.beforeLoad != null) {
        opts.beforeLoad(target);
      }
      var link = $(opts.contentSelector).attr("href");
      if(!link) {
        return; //we are on the end
      }
      nette.ajax(link);
      if (opts.afterLoad != null) {
        opts.afterLoad(target);
      }
    }
  };

  $.fn.scrollPagination.init = function (obj, opts) {
    var target = opts.scrollTarget;
    $(obj).attr('scrollPagination', 'enabled');

    $(target).scroll(function (event) {
      if ($(obj).attr('scrollPagination') == 'enabled') {
        $.fn.scrollPagination.loadContent(obj, opts);
      }
      else {
        event.stopPropagation();
      }
    });
    $.fn.scrollPagination.loadContent(obj, opts);
  };

  $.fn.scrollPagination.defaults = {
    'contentSelector': null,
    'contentData': {},
    'beforeLoad': null,
    'afterLoad': null,
    'scrollTarget': null,
    'heightOffset': 0
  };

  // code for fade in element by element
  $.fn.fadeInWithDelay = function () {
    var delay = 0;
    return this.each(function () {
      $(this).delay(delay).animate({ opacity: 1}, 175);
      delay += 100;
    });
  };

})(jQuery, jQuery.nette);
